var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayforce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 5.73a26.31 26.31 0 010 52.62H15.07v-4.74h13.68a21.58 21.58 0 000-43.15H15.07V5.73z",
    fill: "#3067db"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 10.46a21.58 21.58 0 010 43.15H15.07v-4.73h13.68a16.84 16.84 0 000-33.68H15.07v-4.74z",
    fill: "#3982e8"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PHBhdGggZD0iTTI4Ljc1IDUuNzNhMjYuMzEgMjYuMzEgMCAwIDEgMCA1Mi42MkgxNS4wN3YtNC43NGgxMy42OGEyMS41OCAyMS41OCAwIDAgMCAwLTQzLjE1SDE1LjA3VjUuNzN6IiBmaWxsPSIjMzA2N2RiIi8+PHBhdGggZD0iTTI4Ljc1IDEwLjQ2YTIxLjU4IDIxLjU4IDAgMCAxIDAgNDMuMTVIMTUuMDd2LTQuNzNoMTMuNjhhMTYuODQgMTYuODQgMCAwIDAgMC0zMy42OEgxNS4wN3YtNC43NHoiIGZpbGw9IiMzOTgyZTgiLz48L3N2Zz4=";
export { SvgDayforce as ReactComponent };